import { actionTypes as at, actionCreators } from '../actions';
import { ActionType } from 'typesafe-actions';
import Types from 'Types';

export type Action = ActionType<typeof actionCreators>;

export const initialState = {
  data: null,
  loading: false,
};

export const reducer = (state = initialState, { type, payload }: Action & Types.StoreAction) => {
  switch (type) {
      case at.CONTACT_US:
        return {
          data: null,
          loading: true,
        }
      case at.CONTACT_US_ERROR:
        return {
          ...state,
          loading: false,
          error: payload,
        }
      case at.CONTACT_US_SUCCESS:
        return {
          ...state,
          loading: false,
          data: payload,
        }
      default:
        return state;
  }
};

export const isLoading = ({ submitForm: { contactUs } }: Types.StoreState) => contactUs.loading;

export const getData = ({ submitForm: { contactUs } }: Types.StoreState) => contactUs.data;

